import fetchConfig from './fetch-config';

export default {
  fetchConfig,
};
